"use strict";

exports.__esModule = true;
exports.PointAttachment = void 0;

var _Utils = require("../Utils");

var _Attachment = require("./Attachment");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** An attachment which is a single point and a rotation. This can be used to spawn projectiles, particles, etc. A bone can be
 * used in similar ways, but a PointAttachment is slightly less expensive to compute and can be hidden, shown, and placed in a
 * skin.
 *
 * See [Point Attachments](http://esotericsoftware.com/spine-point-attachments) in the Spine User Guide. */
var PointAttachment = /*#__PURE__*/function (_VertexAttachment) {
  _inheritsLoose(PointAttachment, _VertexAttachment);

  function PointAttachment(name) {
    var _this;

    _this = _VertexAttachment.call(this, name) || this;
    _this.x = 0;
    _this.y = 0;
    _this.rotation = 0;
    /** The color of the point attachment as it was in Spine. Available only when nonessential data was exported. Point attachments
     * are not usually rendered at runtime. */

    _this.color = new _Utils.Color(0.38, 0.94, 0, 1);
    return _this;
  }

  var _proto = PointAttachment.prototype;

  _proto.computeWorldPosition = function computeWorldPosition(bone, point) {
    point.x = this.x * bone.a + this.y * bone.b + bone.worldX;
    point.y = this.x * bone.c + this.y * bone.d + bone.worldY;
    return point;
  };

  _proto.computeWorldRotation = function computeWorldRotation(bone) {
    var cos = _Utils.MathUtils.cosDeg(this.rotation),
        sin = _Utils.MathUtils.sinDeg(this.rotation);

    var x = cos * bone.a + sin * bone.b;
    var y = cos * bone.c + sin * bone.d;
    return Math.atan2(y, x) * _Utils.MathUtils.radDeg;
  };

  _proto.copy = function copy() {
    var copy = new PointAttachment(this.name);
    copy.x = this.x;
    copy.y = this.y;
    copy.rotation = this.rotation;
    copy.color.setFromColor(this.color);
    return copy;
  };

  return PointAttachment;
}(_Attachment.VertexAttachment);

exports.PointAttachment = PointAttachment;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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